import { Typography } from "@lyfegen-platform/react-common";
import { Box, Divider, useTheme } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import startUpper from "../../../utils/start-upper";
import useStyles from "../use-styles";

const Forms = (props: { children: React.ReactNode }) => {
	const { formsHeader, formsContent } = useStyles();
	const { t } = useTranslation();
	const { palette } = useTheme();

	return (
		<>
			<Box className={formsHeader}>
				<Typography type={"h5"} color={"textSecondary"}>
					{startUpper(t("forms"))}
				</Typography>
			</Box>
			<Box justifyContent="space-between" width="100%" display="flex" alignItems="center" pb={2}>
				<Divider style={{ flexGrow: 1, backgroundColor: palette.tableDivider.main }} />
			</Box>
			<Box className={formsContent}>{props.children}</Box>
		</>
	);
};

export default Forms;
